/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Get the formatted time out of the timestamp.
 * @param {string} timestamp The timestamp value.
 * @param {string} locale The desired locale date and time format.
 * @returns {string} The formatted time.
 */
export const getFormattedTime = (timestamp: string, locale = 'en-US'): string => {
  const dateAndTimeObj = new Date(timestamp);

  const time = dateAndTimeObj.toLocaleTimeString(locale);

  return time;
};
